export { default } from './TypeOfReadingScreen';
